<script setup lang="ts">
	const { label = 'Jetzt anmelden' , link } = defineProps<{
		label?: string,
		link: string
	}>()

	const cover = {
		animate: { width: '50%'}
	}
	const logo = {
		animate: { x: '0%' }
	}
</script>

<template>
	<Motion
		as="a" :href="link" target="_blank" class="relative w-full h-17.5 overflow-hidden bg-white"
		whileHover="animate"
		whilePress="animate"
	>
		<Motion
			as="span"
			class="flex w-full h-full bg-primary px-3.5 py-2 leading-tight absolute left-0 top-0"
			:initial="{
				width: '100%'
			}"
			:transition="{
				duration: 0.3,
			 	ease: 'easeInOut'
			}"
			:variants="cover"
		>
			<span class="flex-none z-5 text-white font-bold text-[1rem] xs:text-[1.25rem] m-auto">{{ label }}</span>
			<span class="absolute z-0 right-0 top-0 w-10 aspect-square rotate-45 translate-x-1/4 translate-y-4 bg-primary"></span>
		</Motion>
		<Motion
			as="span"
			class="flex flex-row justify-end w-full h-full border border-b-primary px-3.5 py-3.5 leading-tight absolute left-0 top-0"
			:initial="{ x: '-100%' }"
			:transition="{
				duration: 0.25,
			 	ease: 'easeInOut'
			}"
			:variants="logo"
		>
			<img v-lazy-load  data-src="@/assets/img/davengo-logo.webp" alt="davengo" class="my-auto h-5.5 xs:h-7 sm:h-8 xl:h-7 2xl:h-8" />
		</Motion>
	</Motion>
</template>
